import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  Grid,
  Typography,
  Button,
  CircularProgress,
} from '@material-ui/core';

import IdentityRegister from 'components/IdentityRegister';
import { RootState } from 'store';
import { setIsCreating } from 'modules/identity';

import { useStyles } from './styles';
import { isLoading } from 'utils/loading';

const IdentityList: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { loading: identityLoading, list } = useSelector(
    (state: RootState) => state.identityList,
  );
  const { isCreating } = useSelector((state: RootState) => state.identity);

  const { permissions, loading: userLoading } = useSelector(
    (state: RootState) => state.user,
  );

  const loading = isLoading([identityLoading, userLoading]);

  return (
    <Box p={1}>
      <Grid container direction="column">
        <Grid
          item
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={classes.header}
        >
          <Grid item>
            <Typography
              data-cy="settings-identities__label--title"
              variant="h4"
            >
              Usuários
            </Typography>
          </Grid>
          <Grid item>
            {permissions['identity:create'] && (
              <Button
                data-cy="settings-identities__button--create-identity"
                variant="contained"
                color="primary"
                onClick={() => dispatch(setIsCreating(true))}
              >
                Criar novo Usuário
              </Button>
            )}
          </Grid>
        </Grid>
        <Grid item>
          {loading ? (
            <Box display="flex" justifyContent="center">
              <CircularProgress />
            </Box>
          ) : !permissions['identity:list'] ? (
            <Typography>
              Sem permissão para visualizar a listagem de Usuários.
            </Typography>
          ) : (
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignItems="stretch"
            >
              {isCreating && (
                <IdentityRegister
                  identity={{
                    _id: 'new',
                    identity: '',
                    policies: [],
                    password: '',
                  }}
                />
              )}

              {list.map((identity) => (
                <IdentityRegister key={identity._id} identity={identity} />
              ))}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default IdentityList;
